import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { DeepReactive } from '@jack-henry/frontend-utils/lit';
import { Wire, WireTemplate, WireType } from '@treasury/domain/wires';
import { TmBaseComponent, TmFooterService } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { WireAction, WireWorkflow } from '../../types/wire-workflow-parameters.type';
import './wire-template-editable';

export const tagName = 'wire-template-initiate-step';
@customElement(tagName)
export class WireTemplateInitiateStep extends TmBaseComponent {
    @InjectProperty()
    declare private readonly footerService: TmFooterService;

    @state()
    private wire?: Wire;

    @state()
    private wireTemplate?: WireTemplate;

    @state()
    private action = '' as WireAction;

    @state()
    private workflow = '' as WireWorkflow;

    @state()
    private wireType = WireType.Domestic;

    @state()
    private validWire = false;

    @DeepReactive()
    private validState = {
        accountNumber: false,
        wireCompany: false,
        debitAccount: false,
        amount: false,
        purpose: false,
    };

    protected firstUpdated() {
        this.configureFooter();
    }

    protected render() {
        return html`<wire-template-editable
            .wire=${this.wire}
            .wireTemplate=${this.wireTemplate}
            .wireType=${this.wireType}
            .action=${this.action}
            .workflow=${this.workflow}
            @update=${({ detail }: CustomEvent) => {
                this.wire = detail.wire;
                this.checkValidState();
            }}
            @view-creditor-detail=${() => {
                this.dispatchEvent(new CustomEvent('view-creditor-detail', { detail: true }));
            }}
        ></wire-template-editable>`;
    }

    private configureFooter() {
        this.footerService.configure({
            direction: 'column',
            buttonConfig: [
                {
                    text: 'Review',
                    disabled: Object.values(this.validState).some(isValid => !isValid),
                    onClick: () => {
                        this.dispatchEvent(new CustomEvent('review', { detail: this.wire }));
                    },
                },
            ],
        });
    }

    private checkValidState() {
        if (this.wire) {
            this.validState.accountNumber = !!this.wire.beneficiary.accountNumber;
            this.validState.wireCompany = !!this.wire.wireCompany?.id;
            this.validState.debitAccount = !!this.wire.debitAccount?.id;
            this.validState.amount = !!this.wire.amount;
            this.validState.purpose = !!this.wire.purpose?.length;
        }
        this.configureFooter();
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireTemplateInitiateStep;
    }
}
